import {enableProdMode} from '@angular/core';
import {environment} from "./environments/environment";
import {bootstrapApplication} from "@angular/platform-browser";
import {appConfig} from "./app.config";
import {AppComponent} from "./app/app.component";

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error("Loading bootstrap failed with error: " + err));
